export enum SearchItemType {
    Store = "STORE",
    Locality = "LOCALITY",
}

export type SearchItem = {
    value: string;
    label?: string;
    highlightedLabel?: string;
    type?: SearchItemType;
    latitude?: number;
    longitude?: number;
};
